import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilesAccesoService {

  private readonly base = '/company/access-profiles';

  constructor(private api: ApiService) {}

  // `token` es legacy y se ignora (el token va en el header Bearer).

  listarPerfiles(_token?: any): Observable<any> {
    return this.api.post(`${this.base}/profiles/list`, {});
  }

  listarPermisos(_token?: any): Observable<any> {
    return this.api.post(`${this.base}/permissions/list`, {});
  }

  listarPermisosPorPerfil(_token: any, profileId: number): Observable<any> {
    return this.api.post(`${this.base}/profiles/permissions`, { profileId });
  }

  actualizarPermisosPerfil(_token: any, profileId: number, permissions: string[]): Observable<any> {
    return this.api.post(`${this.base}/profiles/permissions/update`, { profileId, permissions });
  }

  crearPerfil(_token: any, name: string, permissions: string[]): Observable<any> {
    return this.api.post(`${this.base}/profiles/create`, { name, permissions });
  }

  actualizarPerfil(_token: any, profileId: number, name: string): Observable<any> {
    return this.api.post(`${this.base}/profiles/update`, { profileId, name });
  }

  eliminarPerfil(_token: any, profileId: number): Observable<any> {
    return this.api.post(`${this.base}/profiles/delete`, { profileId });
  }
}
